/* Page-only journey. Personal words always use textContent or textarea.value. */
document.addEventListener('DOMContentLoaded', () => {
  const finder = document.querySelector('[data-adaptive-finder]');
  const core = window.WoteRitualFinderCore;
  if (!finder || !core) return;
  const $ = (selector) => finder.querySelector(selector);
  const form = $('[data-finder-form]');
  const result = $('[data-finder-result]');
  const legend = $('[data-finder-question]');
  const hint = $('[data-finder-hint]');
  const options = $('[data-finder-options]');
  const writing = $('[data-finder-writing]');
  const words = $('[data-finder-words]');
  const error = $('[data-finder-error]');
  const next = $('[data-finder-next]');
  const back = $('[data-finder-back]');
  const media = window.matchMedia('(prefers-reduced-motion: reduce)');
  let answers = {};
  let current = 0;
  let ownedDraft = null;
  const storage = () => { try { return window.sessionStorage; } catch (_) { return null; } };
  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  const button = (text, className, action) => {
    const node = element('button', className, text);
    node.type = 'button'; node.addEventListener('click', action);
    return node;
  };
  const link = (text, url, className) => {
    const node = element('a', className, text); node.href = url; return node;
  };
  const clearOwnedDraft = () => { core.clearDraft(storage(), ownedDraft); ownedDraft = null; };
  const motionScroll = (node) => node.scrollIntoView({ behavior: media.matches ? 'auto' : 'smooth', block: 'start' });
  function setError(text) {
    error.textContent = text; error.hidden = !text;
    words.setAttribute('aria-invalid', current === 3 && text ? 'true' : 'false');
  }
  function updateBearing() {
    const q = core.question(current, answers);
    const selected = q.options?.find((choice) => choice.value === answers[q.key]);
    const angle = current * 52 - 24 + Math.max(0, q.options?.indexOf(selected) || 0) * 18;
    $('[data-finder-needle]').style.transform = 'rotate(' + angle + 'deg)';
    $('[data-finder-bearing]').textContent = selected ? selected.title + ' selected.' : q.type === 'text' ? 'A little space for your own words.' : 'Choose what feels right for you.';
  }
  function show(index, focus = true) {
    current = Math.max(0, Math.min(core.KEYS.length - 1, index));
    const q = core.question(current, answers);
    form.hidden = false; result.hidden = true;
    result.replaceChildren();
    legend.replaceChildren(element('small', '', 'Question ' + (current + 1) + ' of ' + core.KEYS.length), document.createTextNode(q.title));
    hint.textContent = q.hint;
    options.replaceChildren();
    writing.hidden = q.type !== 'text'; options.hidden = q.type === 'text';
    words.disabled = q.type !== 'text'; words.required = q.type === 'text';
    if (q.type === 'text') {
      words.value = answers.words || '';
      $('[data-finder-word-count]').textContent = words.value.length + ' / 1,600';
    } else {
      q.options.forEach((choice) => {
        const label = element('label');
        const input = element('input');
        input.type = 'radio'; input.name = q.key; input.value = choice.value;
        input.required = true; input.checked = answers[q.key] === choice.value;
        input.setAttribute('aria-describedby', hint.id);
        const text = element('span');
        text.append(element('b', '', choice.title), element('small', '', choice.detail));
        label.append(input, text);
        input.addEventListener('change', () => {
          if (!input.checked) return;
          clearOwnedDraft(); answers = core.answer(answers, current, input.value);
          setError(''); updateBearing();
        });
        options.append(label);
      });
    }
    back.hidden = current === 0;
    next.textContent = current === core.KEYS.length - 1 ? 'Prepare my letter' : 'Continue';
    $('[data-finder-count]').textContent = String(current + 1).padStart(2, '0') + ' / ' + String(core.KEYS.length).padStart(2, '0');
    $('[data-finder-progress]').style.width = (current + 1) / core.KEYS.length * 100 + '%';
    $('[data-finder-progressbar]').setAttribute('aria-valuenow', String(current + 1));
    $('[data-finder-progressbar]').setAttribute('aria-valuemax', String(core.KEYS.length));
    setError(''); updateBearing();
    if (focus) { legend.focus({ preventScroll: true }); motionScroll(form); }
  }
  words.addEventListener('input', () => {
    clearOwnedDraft(); answers = core.answer(answers, 3, words.value);
    $('[data-finder-word-count]').textContent = words.value.length + ' / 1,600';
    if (!error.hidden && core.valid(3, answers)) setError('');
  });
  function restart() { clearOwnedDraft(); answers = {}; words.value = ''; show(0); }
  function edit(index) { clearOwnedDraft(); answers = core.rewind(answers, index); show(index); }
  function makeLetter(recommendation) {
    const body = element('div', 'finder-result__body finder-letter');
    body.append(element('span', 'finder-result__eyebrow', 'A starting point, in your own words'));
    const title = element('h2', '', recommendation.title); title.tabIndex = -1;
    body.append(title, element('p', 'finder-letter__lead', recommendation.explanation));
    body.append(element('small', 'finder-letter__label', 'The intention you brought with you'));
    body.append(element('blockquote', 'finder-letter__words', recommendation.intention));
    const reason = element('div', 'finder-result__reason');
    const direction = element('div');
    direction.append(element('small', '', 'Your chosen movement'), element('strong', '', recommendation.movement));
    const scope = element('div');
    scope.append(element('small', '', 'Your chosen scope'), element('strong', '', recommendation.depthName));
    reason.append(direction, scope); body.append(reason, element('p', 'finder-letter__note', recommendation.note));
    const actions = element('div', 'finder-result__actions');
    if (recommendation.productHandle) {
      const url = core.productURL(recommendation, window.location.href);
      const fallback = element('div', 'finder-transfer-fallback'); fallback.hidden = true;
      const fallbackMessage = element('p', '', 'This browser could not save your temporary draft. Your letter is still here: copy your words, then continue and paste them into the product form.');
      fallbackMessage.tabIndex = -1;
      const cta = button('Personalize this spell →', 'button button--wine', () => {
        const handoff = core.handoff(recommendation, window.location.href, storage());
        if (handoff.ok) { ownedDraft = handoff.id; window.location.assign(handoff.url); return; }
        fallback.hidden = false; fallbackMessage.focus({ preventScroll: true });
      });
      cta.setAttribute('data-finder-product-cta', '');
      actions.append(cta);
      body.append(element('p', 'finder-letter__privacy', 'Continue only if you want these words carried into the product form. You can review or remove them there before ordering.'));
      const manual = element('textarea'); manual.readOnly = true; manual.value = recommendation.intention;
      manual.rows = 5; manual.setAttribute('aria-label', 'Your words, ready to copy');
      fallback.append(fallbackMessage, manual, button('Select my words', 'text-link', () => { manual.focus(); manual.select(); }), link('Continue without a saved draft →', url, 'text-link'));
      body.append(actions, fallback);
    }
    const editAnswers = element('details', 'finder-edit');
    editAnswers.append(element('summary', '', 'Review or edit my answers'));
    const editList = element('div', 'finder-edit__list');
    core.KEYS.forEach((_, index) => {
      const q = core.question(index, answers);
      const selection = q.type === 'text' ? 'Your own words' : q.options.find((o) => o.value === answers[q.key]).title;
      editList.append(button((index + 1) + '. ' + selection + ' — Edit', 'text-link', () => edit(index)));
    });
    editAnswers.append(editList, element('p', '', 'Editing an earlier choice asks you to choose the following steps again. Your own words are kept for you to review.'));
    body.append(editAnswers, button('Clear my answers & start again', 'finder-result__restart', restart));
    return { body, title };
  }
  function reveal() {
    const recommendation = core.recommend(answers);
    if (!recommendation) return;
    form.hidden = true; result.hidden = false; result.replaceChildren(); result.classList.add('is-sealed');
    const visual = element('div', 'finder-result__visual finder-result__visual--depth-' + recommendation.depth);
    visual.setAttribute('aria-hidden', 'true');
    const envelope = element('div', 'finder-envelope');
    envelope.append(element('p', 'finder-result__eyebrow', 'Prepared from your choices'), element('h2', '', 'A letter for your next beginning.'));
    const seal = button('Open my letter', 'finder-seal', () => {
      const { body, title } = makeLetter(recommendation);
      envelope.replaceWith(body); result.classList.remove('is-sealed');
      title.focus({ preventScroll: true }); motionScroll(result);
    });
    envelope.append(seal, element('p', '', 'A suggestion, not a verdict. Your choice remains your own.'), button('Back to my last answer', 'text-link', () => edit(core.KEYS.length - 1)), button('Clear & start again', 'finder-result__restart', restart));
    result.append(visual, envelope);
    seal.focus({ preventScroll: true }); motionScroll(result);
  }
  function advance() {
    if (!core.valid(current, answers)) {
      setError(current === 3 ? 'Please write between 10 and 1,600 characters in your own words.' : 'Choose the answer that feels closest before continuing.');
      (current === 3 ? words : options.querySelector('input'))?.focus(); return;
    }
    if (current === core.KEYS.length - 1) reveal(); else show(current + 1);
  }
  next.addEventListener('click', advance);
  back.addEventListener('click', () => show(current - 1));
  // No native GET or FormData submission; Enter in the textarea remains a newline.
  form.addEventListener('submit', (event) => { event.preventDefault(); if (document.activeElement !== words) advance(); });
  $('[data-finder-fallback]').hidden = true;
  show(0, false);
});
